import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import type { StateReferenceDTO } from './types';

export const useGetStateReferences = () =>
	useQuery<StateReferenceDTO[]>({
		queryKey: ['state-references'],
		queryFn: async () => {
			const { data } = await api.get<StateReferenceDTO[]>('/state-reference/findAll');
			return data;
		},
	});
